<template>
    <div class="animated fadeIn flex-row align-items-center member-profile">
        <div class="container">
            <b-card no-body>
                <b-tabs card vertical pills>
                    <b-tab title="Account">
                        <div class="text-center">
                            <h3 class="m-0">Account</h3>
                            <small>Edit your account settings and change your password here</small>
                        </div>
                        <hr>
                        <b-form>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                label="Username">
                                <b-form-input v-model="model.username" readonly=""></b-form-input>
                            </b-form-group>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                label="Email">
    
                                <b-input-group>
                                    <b-form-input type="email"  v-model="model.email" readonly=""></b-form-input>
                                    <b-input-group-append>
                                        <b-btn text="Button" variant="success">
                                            <i class="fa fa-pencil"></i>                                            
                                        </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                                
                            </b-form-group>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                label="Mobile No">
    
                                <b-input-group>
                                    <b-form-input v-model="model.mobile" readonly=""></b-form-input>
                                    <b-input-group-append>
                                        <b-btn text="Button" variant="success">
                                            <i class="fa fa-pencil"></i>                                            
                                        </b-btn>
                                    </b-input-group-append>
                                </b-input-group>
                                
                            </b-form-group>
                            <hr>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                label="Password">
                                <b-form-input type="password" placeholder="Enter current password" v-model="pwdObj.password" :state="!$v.pwdObj.password.$error"></b-form-input>
                                <b-form-input type="password" placeholder="Enter new password" class="mt-2" v-model="pwdObj.new_password" :state="!$v.pwdObj.new_password.$error"></b-form-input>
                                <b-form-input type="password" placeholder="Re-type new password" class="mt-2" v-model="pwdObj.confirm_password" :state="!$v.pwdObj.confirm_password.$error"></b-form-input>
                            </b-form-group>
                        </b-form>
                        <hr>
                        <div class="text-center">
                            <b-button variant="danger" class="pl-4 pr-4" @click="changePwd()">
                                <i class="fa fa-floppy-o mr-1"></i>
                                Change Password 
                            </b-button>
                            <b-button variant="info" class="ml-2" @click="resetPwdConfirm()">
                                <i class="fa fa-refresh"></i>
                                Reset Password 
                            </b-button>
                        </div>
                    </b-tab>

                    <b-tab title="Personal Information">
                        <div class="text-center">
                            <h3 class="m-0">Personal Information</h3>
                            <small>Add information about yourself</small>
                        </div>
                        <hr>
                        <b-form>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Nama</label>
                                    <div class="col-md-8">
                                        <b-form-input autofocus :state="model.fullname?true:false" required v-model="model.full_name"></b-form-input>
                                    </div>
                                </div>
                            </div>                                                                    
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Tanggal Lahir</label>
                                    <div class="col-md-8">
                                        <b-form-input type="date"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Kota Lahir</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Jenis Kelamin</label>
                                    <div class="col-md-8">
                                        <v-select v-model="model.gender" placeholder=" -- Pilih Jenis Kelamin -- " :options="data.genders"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Agama</label>
                                    <div class="col-md-8">
                                        <v-select v-model="model.religion" placeholder=" -- Pilih Agama -- " :options="data.religions"></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Alamat</label>
                                    <div class="col-md-8">
                                        <b-form-input v-model="model.address1"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label"></label>
                                    <div class="col-md-8">
                                        <b-form-input v-model="model.address2"></b-form-input>
                                    </div>
                                </div>
                            </div>

                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Province</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Kota</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Kecamatan</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Kelurahan</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>                                                        
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Kodepos</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Pendidikan</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Profesi</label>
                                    <div class="col-md-8">
                                        <b-form-input></b-form-input>
                                    </div>
                                </div>
                            </div>

                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">Nama Bank</label>
                                    <div class="col-md-8">
                                        <b-form-input v-model="model.bank_name"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="b-form-group form-group">
                                <div class="form-row">
                                    <label class="col-md-4 col-form-label">No Rekening</label>
                                    <div class="col-md-8">
                                        <b-form-input v-model="model.bank_rekno"></b-form-input>
                                    </div>
                                </div>
                            </div>
                        </b-form>
                        <hr>
                        <div class="text-center">
                            <b-button variant="success" class="pl-4 pr-4">
                                <i class="fa fa-floppy-o mr-1"></i>
                                Save
                            </b-button>
                        </div>
                    </b-tab>
                    <b-tab title="Public Profile">
                        <div class="text-center">
                            <h3 class="m-0">Public Profile</h3>
                            <small>Add a nice information of yourself for your profile</small>
                        </div>
                        <hr>
                        <b-form>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                label="Image Preview">
                                <b-img v-if="!profile.imageData" style="max-height:300px" thumbnail fluid src="img/no-image2.jpg" alt="Thumbnail" />
                                <b-img v-if="profile.imageData" style="max-height:300px" thumbnail fluid :src="profile.imageData" alt="Thumbnail" />
                            </b-form-group>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                label="Add / Change Image">
                                <b-form-file 
                                    :state="Boolean(model.file)"
                                    v-model="model.file"
                                    @change="previewImage" accept="image/*"
                                    placeholder="Choose a file...">
                                </b-form-file>
                            </b-form-group>
                            <b-form-group
                                horizontal
                                :label-cols="4"
                                breakpoint="lg"
                                placeholder="Enter something"
                                label="Profile Text">
                                <b-form-textarea
                                    :rows="6"
                                    :max-rows="10"></b-form-textarea>
                            </b-form-group> 
                        </b-form>
                        <hr>
                        <div class="text-center">
                            <b-button variant="success" class="pl-4 pr-4">
                                <i class="fa fa-floppy-o mr-1"></i>
                                Save
                            </b-button>
                        </div>
                    </b-tab>
                </b-tabs>
            </b-card>
        </div>
      <b-modal v-model="showResetPwdConfirm" title="RESET PASSWORD?" :centered="true" @ok="resetPwd">
        <p class="text-danger mb-1" >Your Password will be reset, new password will be send to <strong>EMAIL</strong></p>
        <p class="font-weight-bold mb-1" style="text-align:center;">Are you sure?</p>
      </b-modal>

    </div>
</template>

<style lang="scss">
.member-profile {
  .tab-content {
    border: none;
    border-top: 1px solid #c8ced3;
  }
}
</style>

<script>
import vSelect from "vue-select";
import dropdown from "../data/dropdown";
import auth from "../apis/auth";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components: { vSelect},
  mixins: [validationMixin],
  validations: {
        model: {
            username: { required },
        },
        pwdObj: {
            new_password: { required },
            confirm_password: { required },
            password: { required }
        },
  }, 
  data() {
    return {
      model: {},
      pwdObj:{new_password:'',confirm_password:'',password:''},
      profile: { file: null, imageData: "" },
      showResetPwdConfirm:false,
      data: {
        genders: dropdown.genders,
        religions: dropdown.religions
      }
    };
  },
  computed: {
    invalidPassword() {
      this.$v.pwdObj.$touch();
      return this.$v.pwdObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    file() {
      return this.model.file;
    }
  },
  created: async function() {
    this.model = await auth.me();
    // console.log(this.model);
  },
  methods: {
    previewImage: function(event) {
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.profile.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    changePwd: async function() {
        if (this.invalidPassword) {
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else if(this.pwdObj.new_password !== this.pwdObj.confirm_password) {
            toastr.error('konfirmasi password tidak sama','ERROR MESSAGE',10000);
            return;
        } else if(this.pwdObj.new_password == this.pwdObj.password) {
            toastr.error('password baru tidak boleh sama dengan password lama','ERROR MESSAGE',10000);
            return;
        } else {
            try {
                this.pwdObj.username=this.model.username;
                await auth.change_password(this.pwdObj);
                toastr.success('Change Password Successfully','INFORMATION',10000);
                if ((this.$store.state.prevRoute.name) && (this.$route.name !==this.$store.state.prevRoute.name)) {
                    router.push({name:this.$store.state.prevRoute.name});
                } else {
                   router.push("home");
                }

            } catch (error) {
                console.log('Change Password : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }

            }
        }
    },
    resetPwdConfirm: function() {
        this.showResetPwdConfirm=true;
    },
    resetPwd: async function() {
            try {
                this.model = await auth.me();
                await auth.reset_password(this.model);
                toastr.success('Reset Password Successfully');
            } catch (error) {
                console.log('Reset Password : ', error);
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }

            }
    }
  }
};
</script>
